import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { ReactComponent as DeliveredIcon } from "../../../images/message-delivered.svg";
import { ReactComponent as SeenIcon } from "../../../images/message-seen.svg";
import "./index.scss";

const STATUS_CONFIG = {
    DELIVERED: { labelKey: "chat.messageStatus.delivered", Icon: DeliveredIcon, modifier: "delivered" },
    SEEN: { labelKey: "chat.messageStatus.seen", Icon: SeenIcon, modifier: "seen" },
};

function MessageStatus({ status }) {
    const { t } = useTranslation("common");

    if (!status) {
        return null;
    }

    const normalized = String(status).toUpperCase();
    const config = STATUS_CONFIG[normalized];

    if (!config) {
        return null;
    }

    const { labelKey, Icon, modifier } = config;
    const label = t(labelKey);

    return (
        <span
            className={`message-status message-status--${modifier}`}
            aria-label={label}
            title={label}
            role="img"
        >
            <Icon aria-hidden="true" focusable="false" />
            <span className="message-status__sr">{label}</span>
        </span>
    );
}

MessageStatus.propTypes = {
    status: PropTypes.string,
};

MessageStatus.defaultProps = {
    status: null,
};

export default MessageStatus;
